import { Component, effect, ElementRef, inject, input, InputSignal, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DetailsButtonComponent } from '../../layouts/details-button/details-button.component';
import { IframeComponent } from './components/iframe/iframe.component';
import { ModalController } from '@ionic/angular';
import { SpeakerComponent } from './components/speaker/speaker.component';
import { UserService } from 'src/app/services/user.service';
import { Image360Component } from './components/image-360/image-360.component';
import { EventQRComponent } from './components/event-qr/event-qr.component';
import { AuthService } from 'src/app/services/auth.service';
import { PDFViewerComponent } from 'src/app/shared/pdf-viewer/pdf-viewer.page';
import Swal from'sweetalert2';
import Swiper from 'swiper';
import SwiperCore from 'swiper';
import { FreeMode } from 'swiper';
import { ShiftScrollService } from 'src/app/services/shift-scroll.service';

SwiperCore.use([FreeMode]);

@Component({
  selector: 'details-action-buttons',
  standalone: true,
  imports: [
    TranslateModule,
    DetailsButtonComponent,
  ],
  templateUrl: './action-buttons.component.html',
  styleUrl: './action-buttons.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class ActionButtonsDetailsLinksComponent {
  public swiperRef = viewChild.required<ElementRef>('swiper');
  
  public actionButtons: InputSignal<any> = input.required<any>();
  public image360: InputSignal<any> = input<any>(null);
  public speaker: InputSignal<any> = input<any>([]);
  public itemId: InputSignal<any> = input<any>(null);
  public fromBottomSheet: InputSignal<boolean> = input.required<boolean>();

  public translate = inject(TranslateService);
  private modalController = inject(ModalController);
  private userService = inject(UserService);
  private authService = inject(AuthService);
  private _shiftScrollService = inject(ShiftScrollService);
  
  public populatedImage360: any = null;
  
  private _swiperInstance!: Swiper;
  private _shiftScrollElementId?: string;
  private _domReady = signal(false);
  
  setSWiper = effect(() => {
    if(!this._domReady() || !this.swiperRef()) return;
    
    const swiperEl = this.swiperRef().nativeElement;
    if(!swiperEl) return;

    if (this._swiperInstance && !(this._swiperInstance as any).destroyed)
      return

    const swiperConfig = {
      slidesPerView: "auto" as const,
      spaceBetween: 8,
    };
    
    this._swiperInstance = new Swiper(swiperEl, swiperConfig);
    
    // Configurar Swiper con Shift+Scroll y guardar el ID del elemento
    this._shiftScrollElementId = this._shiftScrollService.setupSwiperShiftScroll(this._swiperInstance, swiperEl);
  }, { allowSignalWrites: true })

  ngOnInit(){
    this.populatedImage360 = this.getImage360();
    this.userService.checkUserEventsInscriptions();
  }
  
  ngAfterViewInit(): void {
    this._domReady.set(true);
  }

  getImage360(){
    if (!this.image360())
      return null;

    try{
      const data = JSON.parse(this.image360());
      return data?.[0]?.src || null
    } catch(e){
      return null;
    }
  }

  goToLogin(){
    this.userService.login();
  }

  actionButton(item: any){
    switch(item?.type){
      case 'iframe': this.openIframe(item); break;
      case 'qr': this.openExternalLink(item?.url); break;
      case 'link': this.openExternalLink(item?.url); break;
      case 'pdf': this.openPDFModal(item?.button_text, item?.url)
    }
  }

  async openIframe(item){
    const iframeModal = await this.modalController.create({
      component: IframeComponent,
      cssClass: "modal360",
      componentProps: {
        url: item.url,
        title: item.button_text,
      },
    });
    await iframeModal.present();
  }

  openExternalLink(url){
    if (!url || url === '')
      return;
    
    window.open(url, "_blank");
  }

  async openPDFModal(name, pdf) {
    const pdfModal = await this.modalController.create({
      component: PDFViewerComponent,
      cssClass: "pdfModal",
      componentProps: { pdf: pdf, name: name },
    });
    await pdfModal.present();
  }

  async showSpekaer(){
    const showSpeakerModal = await this.modalController.create({
      component: SpeakerComponent,
      cssClass: "qrEventModal",
      componentProps: { speaker: null }
    });
    await showSpeakerModal.present();
  }

  async showImage360() {
    const image360 = await this.modalController.create({
      component: Image360Component,
      cssClass: "image360 detailsModal",
      componentProps: {
        dataPhoto: this.populatedImage360
      }
    });
    await image360.present();
  }

  booking(){
    if (!this.itemId())
      return;
    

    if (!this.authService.isLoggedIn()){
      this.userService.login();
      return;
    }
      
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "booking-buttons",
        cancelButton: "booking-buttons",
        container: "booking-swal"
      },
      buttonsStyling: false
    });

    const swalConfirmBookig = Swal.mixin({
      customClass: {  container: "booking-swal-confirm" },
      buttonsStyling: false
    });

    swalWithBootstrapButtons.fire({
      text: this.translate.instant('¿Seguro de que quieres inscribirte en este evento?'),
      icon: null,
      showCancelButton: true,
      confirmButtonText: `<div style="display: flex; align-items: center;"> <div class="swal-booking-buttons"></div> <span style="margin-left: 5px;">${this.translate.instant('Si')}</span> </div>`,
      cancelButtonText: `<div style="display: flex; align-items: center;"> <div class="swal-booking-buttons"></div> <span style="margin-left: 5px;">${this.translate.instant('No')}</span> </div>`,
      reverseButtons: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.userService.addEventInscription(this.itemId()).subscribe((res: any) => {
          if (res.error){
            Swal.fire({
              title: '',
              text: this.translate.instant(res.error),
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            })
            return;
          }
          this.userService.checkUserEventsInscriptions();
          swalConfirmBookig.fire({
            showConfirmButton: false,
            html: `
              <div style="display: flex; flex-direction: column; align-items: center;">
                <h3>${this.translate.instant('¡Perfecto!')}</h3>
                <svg class="booking-svg-confirm-icon" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M27.1653 38.3041L27.7215 38.1208C32.509 36.5229 34.9028 35.725 35.3465 33.8375C35.7944 31.95 34.009 30.1646 30.4403 26.5979L26.9215 23.077L26.9111 23.1083L26.7403 23.6646C26.5986 24.1437 26.4069 24.8104 26.2174 25.5729C25.8278 27.1354 25.4736 28.9521 25.4736 30.3229C25.4736 31.6937 25.8278 33.5125 26.2174 35.0729C26.4375 35.9505 26.6848 36.8211 26.959 37.6833L26.9694 37.7187L26.9736 37.727L27.1653 38.3041ZM15.5674 42.1687C10.8549 43.7229 8.37152 44.3729 6.99861 43C5.47777 41.4791 6.43819 38.5979 8.35902 32.8375L11.8799 22.2771C13.1965 18.3271 13.9694 16.0062 15.259 15.0666L15.2486 15.1187C15.1456 15.6243 15.0498 16.1313 14.9611 16.6396C14.72 17.9818 14.5047 19.3286 14.3153 20.6791C13.8653 23.8729 13.4507 27.9541 13.6653 31.2146C13.7944 33.1896 14.2049 35.6375 14.5715 37.5479C14.7723 38.5949 14.989 39.6387 15.2215 40.6791L15.2632 40.8729L15.5674 42.1687ZM18.4382 15.1229L18.334 15.6333V15.6396L18.3278 15.6583L18.3132 15.7354C18.2138 16.2201 18.1214 16.7063 18.0361 17.1937C17.802 18.4958 17.593 19.8023 17.409 21.1125C16.9653 24.2687 16.5903 28.0854 16.784 31.0104C16.8986 32.7812 17.2778 35.0729 17.6382 36.9625C17.8332 37.976 18.0437 38.9866 18.2694 39.9937L18.3111 40.1771L18.3215 40.2229L18.5444 41.1791L24.2007 39.2937L23.9861 38.65C23.9012 38.3946 23.8214 38.1376 23.7465 37.8791C23.5944 37.3645 23.3903 36.65 23.184 35.8312C22.784 34.227 22.3486 32.0979 22.3486 30.3229C22.3486 28.5479 22.7861 26.4187 23.184 24.8166C23.4216 23.8682 23.6891 22.9274 23.9861 21.9958L24.0069 21.9396L24.4486 20.6062L23.4007 19.5583C21.2299 17.3833 19.7153 15.8708 18.4382 15.1229ZM22.7632 4.91664C22.9385 5.02344 23.091 5.16373 23.212 5.32949C23.333 5.49525 23.4202 5.68323 23.4686 5.88269C23.517 6.08216 23.5255 6.2892 23.4939 6.49198C23.4622 6.69477 23.3909 6.88933 23.284 7.06455C23.1245 7.32392 23.0571 7.62948 23.0927 7.93188C23.1282 8.23428 23.2646 8.51588 23.4799 8.73122L23.684 8.93539C24.9111 10.1604 25.3632 11.9625 24.8611 13.6229C24.8017 13.8193 24.7043 14.0021 24.5742 14.1609C24.4442 14.3197 24.2842 14.4513 24.1033 14.5482C23.9224 14.6451 23.7242 14.7055 23.52 14.7258C23.3158 14.7461 23.1096 14.726 22.9132 14.6666C22.7168 14.6073 22.5339 14.5098 22.3752 14.3798C22.2164 14.2497 22.0848 14.0897 21.9879 13.9088C21.891 13.728 21.8306 13.5298 21.8103 13.3256C21.79 13.1214 21.8101 12.9152 21.8694 12.7187C21.9523 12.445 21.9592 12.1538 21.8895 11.8764C21.8198 11.599 21.676 11.3458 21.4736 11.1437L21.2694 10.9396C20.5585 10.2286 20.1074 9.2992 19.9887 8.30081C19.87 7.30242 20.0907 6.29314 20.6153 5.43539C20.8313 5.08177 21.179 4.82846 21.5818 4.73117C21.9846 4.63389 22.4096 4.7006 22.7632 4.91664ZM28.2528 9.16038C28.6715 8.74163 28.8819 8.53122 29.1236 8.45414C29.3283 8.38929 29.5481 8.38929 29.7528 8.45414C29.9944 8.53122 30.2049 8.74163 30.6236 9.16038C31.0403 9.57705 31.2507 9.78747 31.3278 10.0291C31.3931 10.2345 31.3931 10.455 31.3278 10.6604C31.2507 10.9021 31.0424 11.1104 30.6236 11.5291C30.2049 11.9479 29.9944 12.1583 29.7528 12.2354C29.5481 12.3002 29.3283 12.3002 29.1236 12.2354C28.8819 12.1583 28.6715 11.9479 28.2528 11.5291C27.834 11.1125 27.6236 10.9021 27.5486 10.6604C27.4833 10.455 27.4833 10.2345 27.5486 10.0291C27.6236 9.78747 27.834 9.57913 28.2528 9.16038ZM14.4319 8.2083C14.5359 8.10448 14.6593 8.02214 14.7951 7.966C14.9309 7.90987 15.0764 7.88102 15.2233 7.88112C15.3702 7.88122 15.5157 7.91025 15.6514 7.96657C15.7871 8.02289 15.9104 8.10538 16.0142 8.20934C16.1181 8.31331 16.2004 8.4367 16.2565 8.57248C16.3127 8.70827 16.3415 8.85378 16.3414 9.00071C16.3413 9.14763 16.3123 9.29311 16.256 9.42881C16.1996 9.56452 16.1172 9.68781 16.0132 9.79163C15.8032 10.0013 15.5186 10.119 15.2218 10.1188C14.9251 10.1186 14.6406 10.0006 14.4309 9.79059C14.2212 9.58063 14.1035 9.29597 14.1037 8.99923C14.1039 8.70249 14.222 8.41799 14.4319 8.2083ZM41.6153 14.6812C41.3257 14.7916 41.0715 15.0479 40.559 15.5583C40.0486 16.0708 39.7924 16.325 39.6819 16.6146C39.5521 16.9518 39.5521 17.3252 39.6819 17.6625C39.7924 17.95 40.0486 18.2062 40.559 18.7187C41.0715 19.2291 41.3257 19.4854 41.6153 19.5958C41.9525 19.7256 42.3259 19.7256 42.6632 19.5958C42.9507 19.4854 43.2069 19.2291 43.7194 18.7187C44.2299 18.2062 44.4861 17.95 44.5965 17.6625C44.7264 17.3252 44.7264 16.9518 44.5965 16.6146C44.4861 16.325 44.2299 16.0708 43.7194 15.5583C43.2069 15.0479 42.9507 14.7916 42.6632 14.6812C42.3259 14.5514 41.9525 14.5514 41.6153 14.6812ZM39.7049 31.9021C39.8087 31.7982 39.9319 31.7159 40.0676 31.6597C40.2033 31.6035 40.3486 31.5746 40.4955 31.5746C40.6423 31.5746 40.7877 31.6035 40.9234 31.6597C41.059 31.7159 41.1823 31.7982 41.2861 31.9021C41.3899 32.0059 41.4723 32.1291 41.5285 32.2648C41.5847 32.4004 41.6136 32.5458 41.6136 32.6927C41.6136 32.8395 41.5847 32.9849 41.5285 33.1206C41.4723 33.2562 41.3899 33.3795 41.2861 33.4833C41.0764 33.693 40.792 33.8108 40.4955 33.8108C40.1989 33.8108 39.9145 33.693 39.7049 33.4833C39.4952 33.2736 39.3774 32.9892 39.3774 32.6927C39.3774 32.3961 39.4952 32.1117 39.7049 31.9021ZM36.8549 9.83747C37.2608 9.91892 37.6179 10.1582 37.8476 10.5027C38.0773 10.8473 38.1608 11.2689 38.0799 11.675L37.7799 13.175C37.5764 14.1891 37.1089 15.1316 36.4244 15.9071C35.74 16.6827 34.863 17.2637 33.8819 17.5916C33.4232 17.7437 33.013 18.0148 32.6931 18.3771C32.3732 18.7394 32.1552 19.1801 32.0611 19.6541L31.7611 21.1541C31.6796 21.5605 31.44 21.9179 31.095 22.1476C30.9242 22.2614 30.7326 22.3404 30.5313 22.3801C30.3299 22.4198 30.1227 22.4195 29.9215 22.3791C29.7203 22.3388 29.529 22.2592 29.3585 22.1449C29.1881 22.0306 29.0418 21.8839 28.928 21.713C28.6983 21.3681 28.615 20.9459 28.6965 20.5396L28.9965 19.0396C29.409 16.9771 30.8965 15.2896 32.8924 14.625C33.8257 14.3125 34.5215 13.5271 34.7153 12.5625L35.0153 11.0625C35.0967 10.6565 35.336 10.2994 35.6805 10.0697C36.0251 9.84004 36.4467 9.7565 36.8528 9.83747M44.6007 26.1666C44.2316 26.0051 43.824 25.9527 43.426 26.0154C43.028 26.0782 42.6563 26.2536 42.3549 26.5208C41.5328 27.2494 40.5024 27.7011 39.4096 27.8117C38.3167 27.9224 37.2167 27.6865 36.2653 27.1375L35.8215 26.8812C35.4656 26.6725 35.2066 26.3316 35.1012 25.9327C34.9957 25.5338 35.0523 25.1093 35.2586 24.752C35.4649 24.3947 35.8042 24.1335 36.2024 24.0254C36.6006 23.9173 37.0253 23.971 37.384 24.175L37.8278 24.4312C38.6132 24.8854 39.6028 24.7854 40.2819 24.1812C41.0298 23.5183 41.9517 23.0832 42.9389 22.9274C43.926 22.7716 44.9371 22.9016 45.8528 23.3021L46.4611 23.5687C46.8324 23.7401 47.1216 24.0503 47.2668 24.4326C47.412 24.8148 47.4015 25.2388 47.2376 25.6135C47.0737 25.9881 46.7695 26.2836 46.3903 26.4365C46.011 26.5894 45.5869 26.5875 45.209 26.4312L44.6007 26.1666ZM36.459 20.2958C36.6684 20.0861 36.9526 19.9682 37.2489 19.968C37.5453 19.9678 37.8295 20.0853 38.0392 20.2948C38.2489 20.5042 38.3668 20.7883 38.367 21.0846C38.3672 21.381 38.2497 21.6653 38.0403 21.875C37.8309 22.0847 37.5467 22.2026 37.2504 22.2028C36.954 22.203 36.6698 22.0854 36.4601 21.876C36.2504 21.6666 36.1325 21.3825 36.1323 21.0861C36.1321 20.7898 36.2496 20.5055 36.459 20.2958Z" />
                </svg>
                <p>${this.translate.instant('Ya tienes en tu cartera la inscripción al evento')}</p>
              </div>
            `,
          });
        })
      } 
    });
  }

  checkInscription(){
    const foundInscription = this.userService.eventsInscriptions.find(inscription => inscription.event_id === this.itemId());
    return foundInscription ? true : false;
  }

  async getQRBooking(){
    const qrCode = this.userService.eventsInscriptions.find(inscription => inscription.event_id === this.itemId())?.qr_code;
    if (!qrCode) 
      return;

    const qrModal = await this.modalController.create({
      component: EventQRComponent,
      cssClass: "qrEventModal",
      componentProps: { qrCode, user: this.authService?.userValue?.name ?? this.authService?.userValue?.email}
    });
    await qrModal.present();
  }

  ngOnDestroy(): void {
    try {
      if (this._swiperInstance) 
        this._swiperInstance.destroy(true, true);
    } catch {}
  }

}